var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppleLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4548 10.6354C14.4311 8.1101 16.5233 6.88137 16.6191 6.82374C15.4353 5.09589 13.5981 4.85947 12.9541 4.84083C11.411 4.67813 9.91614 5.76449 9.13145 5.76449C8.34675 5.76449 7.11887 4.85777 5.81642 4.88235C4.13856 4.90862 2.56918 5.87974 1.70737 7.38896C-0.0687829 10.4642 1.2574 14.9834 2.95813 17.4696C3.80892 18.6865 4.80462 20.0483 6.10538 19.9983C7.37987 19.9466 7.85526 19.1865 9.39329 19.1865C10.9313 19.1865 11.3635 19.9983 12.6922 19.9686C14.0591 19.9466 14.9192 18.7458 15.7412 17.5171C16.725 16.1223 17.1199 14.7478 17.136 14.6775C17.1029 14.6664 14.4811 13.664 14.4548 10.6354Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9457 3.20572C12.6304 2.349 13.0998 1.18382 12.9702 0C11.9787 0.0449122 10.7373 0.686395 10.0246 1.52447C9.39161 2.26256 8.8264 3.47434 8.97384 4.61071C10.0873 4.69375 11.2305 4.04973 11.9465 3.20487",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleLogin);
export default __webpack_public_path__ + "static/media/apple_login.9ab41017500d7e7d5303bf5cdd33b8c7.svg";
export { ForwardRef as ReactComponent };